import create from 'zustand';
import {UserInterface} from "../../interface/UserInterface";

interface SessionStore {
    user: any | null;
    setUser: (data: any | null | undefined) => void;
    data?: UserInterface | null;
    setData: (data: UserInterface | null | undefined) => void;
}

export const useSessionStore = create<SessionStore>((set) => ({
    data: null,
    setData: (data: any) => set({ data }),
    user: null,
    setUser: (user: UserInterface) => set({ user }),
}));
